import {ApplicationConfig, provideExperimentalZonelessChangeDetection} from '@angular/core';
import {provideRouter, withComponentInputBinding, withRouterConfig} from '@angular/router';

import {APP_ROUTES} from './app.routes';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {provideAppStore} from './shared/store/store.provider';
import {provideHttpClient, withFetch, withInterceptors} from '@angular/common/http';
import {SessionTokenInterceptor} from './shared/security/interceptors/session-token.interceptor';
import {loggerProviders} from '@kamp-n/ng-logger';
import {APP_THEME_INITIALIZER} from './core/providers/app-init';
import {provideCdnUrlReplacer} from './core/providers/cdn-replacer.provider';

export const appConfig: ApplicationConfig = {
	providers: [
		provideAnimationsAsync(),
		provideRouter(APP_ROUTES,
			//withDebugTracing(),
			withRouterConfig({paramsInheritanceStrategy: 'always'}),
			withComponentInputBinding()
		),
		provideAppStore(),

		provideHttpClient(
			withInterceptors([
				SessionTokenInterceptor
			]),
			withFetch()
		),
		loggerProviders(),
		provideExperimentalZonelessChangeDetection(),
		provideCdnUrlReplacer(),

		APP_THEME_INITIALIZER,

	]
};
